import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=5e7a4bb0&scoped=true&"
import script from "./QuestionItem.vue?vue&type=script&lang=js&"
export * from "./QuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=5e7a4bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a4bb0",
  null
  
)

export default component.exports